import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export const enum fields {
    heading = "heading",
    spacingTop = "spacingTop",
    spacingBottom = "spacingBottom",

    displayHeading = "Accordion heading",
    displaySpacingTop = "Spacing top",
    displaySpacingBottom = "Spacing bottom",
}

export interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.spacingTop]: number;
        [fields.spacingBottom]: number;
    };
}

export const mapStateToProps = (_: ApplicationState, __: OwnProps) => {
    return {};
};

export type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface AccordionWidgetStyles {
    wrapper?: InjectableCss;
    accordion?: InjectableCss;
}

export const accordionWidgetStyles: AccordionWidgetStyles = {};

export const styles = accordionWidgetStyles;

export const AccordionWidget = ({ id, fields: { heading, spacingTop, spacingBottom } }: Props) => {
    const wrapperStyle = styles.wrapper ?? {};
    wrapperStyle.css = css`
        ${wrapperStyle?.css}
        margin-top: ${spacingTop ?? 0}px;
        margin-bottom: ${spacingBottom ?? 0}px;
    `;

    return (
        <StyledWrapper {...wrapperStyle}>
            <Accordion headingLevel={3} {...styles.accordion}>
                <AccordionSection title={heading}>
                    <Zone contentId={id as never} zoneName={"AccordionContent" as never} />
                </AccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

const definitionTab: TabDefinition = {
    displayName: "Definition",
    sortOrder: 1,
};

const stylesTab: TabDefinition = {
    displayName: "Styles",
    sortOrder: 2,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AccordionWidget) as any,
    definition: {
        displayName: "Accordion",
        group: "Verndale Box" as any,
        icon: "arrows-maximize",
        fieldDefinitions: [
            // Definition tab items:
            {
                tab: definitionTab,
                name: fields.heading,
                displayName: fields.displayHeading,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },

            // Styles tab items:
            {
                tab: stylesTab,
                name: fields.spacingTop,
                displayName: fields.displaySpacingTop,
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
            },
            {
                tab: stylesTab,
                name: fields.spacingBottom,
                displayName: fields.displaySpacingBottom,
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
